import { saveAs } from "file-saver";

export const isLocalFile = (file) =>
  typeof Blob !== "undefined" && file instanceof Blob;

const imageExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "svg",
  "bmp",
  "avif",
];
const videoExtensions = ["mp4", "webm", "ogg", "ogv"];

export const getFileMedia = (file) => {
  const local = isLocalFile(file);
  const url = local ? "" : typeof file === "string" ? file : file?.url || "";
  const pathName = url.split(/[?#]/)[0].split("/").pop();
  let name =
    file?.name ||
    file?.title ||
    (url.startsWith("data:") ? "file" : pathName) ||
    "file";
  try {
    name = decodeURIComponent(name);
  } catch (_) {
    /* Keep literal filenames. */
  }
  const sourceName = local ? name : pathName || name;
  const extension = sourceName.includes(".")
    ? sourceName.split(".").pop().toLowerCase()
    : "";
  const type =
    file?.type ||
    (url.startsWith("data:") ? url.slice(5).split(/[;,]/)[0] : "");
  // Match browser-supported media only. Documents (including PDFs) use Download.
  const previewKind =
    imageExtensions.includes(extension) ||
    /^image\/(jpeg|png|gif|webp|svg\+xml|bmp|avif)$/.test(type)
      ? "image"
      : videoExtensions.includes(extension) ||
        /^video\/(mp4|webm|ogg)$/.test(type)
      ? "video"
      : !extension && ["image", "video"].includes(type)
      ? type
      : null;
  return {
    url,
    name,
    extension,
    type,
    previewKind,
    available: local || Boolean(url),
  };
};

export const downloadFileMedia = async (file) => {
  const { url, name, available } = getFileMedia(file);
  if (!available) throw new Error("Missing file");
  if (isLocalFile(file)) {
    saveAs(file, name);
    return;
  }
  // A preview may cache a non-CORS image response. Fetch fresh bytes for the
  // download without altering signed URLs or navigating away from the editor.
  // The storage server must still allow this origin to read the response.
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok) throw new Error("File download failed");
  saveAs(await response.blob(), name);
};
